import {
  Backdrop,
  Box,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { createNumberTracker, deleteNumberTrackerAuto, deleteNumberTrackerByType, updateNumberTracker } from '../../../graphql';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { useSelector } from 'react-redux';
import { Accessibility, Delete, DirectionsRun, Edit } from '@mui/icons-material';
import ListingActive from '../../../components/modals/ListingActive';
import DeleteModal from '../../../components/modals/DeleteModal';
import { handleFreeze } from '../../../utils/common';
const Setting = ({
  item,
  list,
  index,
  yearId,
  setSingle,
  title,
  setMode,
  setItem,
  mode,
  setId,
  length,
  method,
  modal,
  onDelete,
  editId,
  setEditID,
}) => {
  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
  const [activeValueModal, setActiveValueModal] = useState();
  const [modeModal, setModeModal] = useState({ type: false, val: '' });
  const [deleteModal, setDeleteModal] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const modeChange = async (type) => {
    try {
      setBackdropOpen(true);

      if (type === 'MANUAL') {
        await API.graphql(
          graphqlOperation(deleteNumberTrackerByType, {
            deleteNumberTrackerByTypeInput: {
              entrytypecd: modal,
              mode: type,
            },
          })
        );

        // Create new manual number tracker
        const itemSettingsData = {
          entrytypecd: modal,
          serialnumber: '',
          serialisactive: 0,
          serialisused: 0,
          serialflag: 0,
          companyid: getCompany?.companyid,
          financialyearid: setId,
          nextinvoicenumber: -1,
          prefix: '',
          suffix: '',
          startinvoicenumber: 0,
        };

        await API.graphql(
          graphqlOperation(createNumberTracker, {
            createNumberTrackerInput: [itemSettingsData],
          })
        );

        setMode(type);
        showSuccessSnackbar('Settings have been switched to Manual successfully');
      }

      if (type === 'AUTO') {
        await API.graphql(
          graphqlOperation(deleteNumberTrackerByType, {
            deleteNumberTrackerByTypeInput: {
              entrytypecd: modal,
              mode: type,
            },
          })
        );

        // Create new auto number trackers
        let datas = [];
        list.forEach((ele) => {
          let data = {
            entrytypecd: modal,
            serialnumber: ele.prefix && ele.suffix ? `${ele.prefix}/${ele.suffix}` : ele.prefix ? ele.prefix : ele.suffix,
            serialisactive: ele.serialisactive,
            serialisused: ele?.serialisused,
            serialflag: ele?.serialflag,
            companyid: getCompany?.companyid,
            financialyearid: setId,
            nextinvoicenumber: ele.nextinvoicenumber,
            prefix: ele.prefix,
            suffix: ele.suffix,
            startinvoicenumber: ele?.startinvoicenumber ? ele?.startinvoicenumber : ele.nextinvoicenumber,
          };
          datas.push(data);
        });

        await API.graphql(
          graphqlOperation(createNumberTracker, {
            createNumberTrackerInput: datas,
          })
        );

        setMode(type);
        showSuccessSnackbar('Settings have been switched to Auto-generated successfully');

        // Refresh the data after switching to AUTO mode
        setTimeout(() => {
          setSingle(modal, setItem, yearId);
        }, 1000);
      }

      // Close the confirmation modal
      setModeModal({ type: false, val: '' });
    } catch (error) {
      console.error('Error changing mode:', error);
      showErrorSnackbar('Failed to change mode. Please try again.');
    } finally {
      setBackdropOpen(false);
    }
  };

  const handleStatus = async () => {
    const item = activeValueModal;
    const salesSettingsData = {
      id: Number(item.id),
      companyid: item?.companyid,
      serialflag: item?.serialflag || 0,
      startinvoicenumber: item?.startinvoicenumber ? item?.startinvoicenumber : Number(item?.nextinvoicenumber),
      entrytypecd: item?.entrytypecd,
      serialisused: item?.serialisused,
      nextinvoicenumber: Number(item?.nextinvoicenumber),
      financialyearid: item?.financialyearid,
      prefix: item?.prefix ? item?.prefix : '',
      suffix: item.suffix ? item?.suffix : '',
      serialnumber:
        item.prefix && item.suffix
          ? `${item.prefix.trim()}/${item.suffix.trim()}`
          : item.suffix
          ? item.suffix.trim()
          : item.prefix
          ? item.prefix.trim()
          : '',
      serialisactive: item?.serialisactive === 0 ? 1 : 0,
    };

    const resSalesSettings = await API.graphql(
      graphqlOperation(updateNumberTracker, {
        updateNumberTrackerInput: salesSettingsData,
      })
    );
    setItem(
      list.map((itemm) =>
        itemm.id == item.id
          ? {
              ...itemm,
              serialisactive: item?.serialisactive === 0 ? 1 : 0,
            }
          : itemm
      )
    );
    const str = item?.serialisactive === 0 ? 'Active' : 'Inactive';
    showSuccessSnackbar('Settings has been updated to ' + str);
  };
  const handleDelete = async (id) => {
    setBackdropOpen(true);
    const salesSettingsData = {
      id: Number(id),
    };

    const resSalesSettings = await API.graphql(
      graphqlOperation(deleteNumberTrackerAuto, {
        deleteNumberTrackerAutoByTypeInput: salesSettingsData,
      })
    );
    showSuccessSnackbar('Setting deleted');
    onDelete();

    setBackdropOpen(false);
  };
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  return (
    <>
      <TableRow style={{ textAlign: 'left' }} className="noTableCellBorder">
        {index === 0 ? (
          <TableCell align="left" rowSpan={mode === 'MANUAL' ? 1 : length}>
            <Typography>{title}</Typography>
          </TableCell>
        ) : (
          ''
        )}
        {index === 0 ? (
          <TableCell align="left" className={item.serialisactive === 0 ? 'inactive-row' : ''} rowSpan={mode === 'MANUAL' ? 1 : length}>
            <Grid item style={{ display: 'flex' }}>
              <RadioGroup
                name="use-radio-group"
                value={mode}
                onChange={(e) => {
                  if (Freeze === 1) {
                    return handleFreeze();
                  }

                  setModeModal({ type: true, val: e.target.value });
                }}
                style={{
                  display: 'block',
                }}
              >
                <FormControlLabel value="AUTO" label="Auto Generated" control={<Radio />} />
                <FormControlLabel value="MANUAL" label="Manual" control={<Radio />} />
              </RadioGroup>
            </Grid>
          </TableCell>
        ) : (
          ''
        )}
        <TableCell align="left" className={item.serialisactive === 0 ? 'inactive-row' : ''}>
          {mode === 'MANUAL' ? (
            ''
          ) : (
            <>
              <span style={{ marginLeft: '20px' }}>{index + 1}</span>
              <Link
                onClick={() => {
                  if (Freeze === 1) {
                    return handleFreeze();
                  }
                  method(modal);
                }}
                underline="hover"
                style={{
                  display: mode === 'MANUAL' ? 'none' : length !== index + 1 ? 'none' : 'block',
                  cursor: 'pointer',
                  fontSize: '13px',
                }}
              >
                <AddIcon fontSize="15px" />
                {'Add New'}
              </Link>
            </>
          )}
        </TableCell>
        <TableCell
          align="left"
          className={item.serialisactive === 0 ? 'inactive-row' : ''}
          style={{
            padding: '0px!important',
            maxWidth: '120px',
          }}
        >
          {mode === 'MANUAL' ? '' : item.prefix}
        </TableCell>
        <TableCell
          align="left"
          className={item.serialisactive === 0 ? 'inactive-row' : ''}
          style={{
            padding: '0px!important',
            maxWidth: '150px',
          }}
        >
          {mode === 'MANUAL' ? '' : item?.startinvoicenumber}
        </TableCell>
        <TableCell
          align="left"
          className={item.serialisactive === 0 ? 'inactive-row' : ''}
          style={{
            padding: '0px!important',
            maxWidth: '120px',
          }}
        >
          {mode === 'MANUAL' ? '' : item.suffix}
        </TableCell>
        <TableCell
          align="left"
          className={item.serialisactive === 0 ? 'inactive-row' : ''}
          sx={{
            '.MuiTableCell-root': { padding: '0px!important' },
          }}
        >
          {mode === 'MANUAL' ? '' : item?.prefix + item?.startinvoicenumber + item?.suffix}
        </TableCell>
        <TableCell
          align="left"
          className={item.serialisactive === 0 ? 'inactive-row' : ''}
          style={{
            padding: '0px!important',
            maxWidth: '150px',
          }}
        >
          {mode === 'MANUAL' ? '' : item?.prefix + item?.nextinvoicenumber + item?.suffix}
        </TableCell>
        <TableCell
          sx={{
            '&:focus-within': {
              backgroundColor: 'transparent',
            },
          }}
          align="left"
        >
          {mode === 'MANUAL' ? (
            ''
          ) : (
            <Box sx={{ whiteSpace: 'nowrap' }}>
              <Tooltip title={item.serialisactive === 1 ? 'Mark as In-Active' : 'Mark as Active'} placement="left" disableInteractive arrow>
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    if (item?.serialflag == 1 || item?.serialflag == 2) {
                      showWarningSnackbar('Default setting cannot be deactivated');
                    } else if (Freeze === 1) {
                      return handleFreeze();
                    } else {
                      item.active = item.serialisactive;
                      let row = { ...item };
                      setActiveValueModal(row);
                    }
                  }}
                  aria-label="delete"
                  sx={{
                    margin: '0px 2px',
                    padding: '5px',
                    backgroundColor: '#FEF3C7',
                  }}
                >
                  {item.serialisactive == 1 ? (
                    <DirectionsRun sx={{ fontSize: '15px', color: '#E29819' }} />
                  ) : (
                    <Accessibility sx={{ fontSize: '15px', color: '#E29819' }} />
                  )}
                </IconButton>
              </Tooltip>
              <Tooltip title={'Delete'} placement="top" disableInteractive arrow>
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    if (item?.serialflag == 1 || item?.serialflag == 2) {
                      showWarningSnackbar('Default settings cannot be deleted');
                    } else if (item?.serialisused == 1) {
                      showWarningSnackbar("You can't delete the setting because there are relevant transactions that exist");
                    } else if (Freeze === 1) {
                      return handleFreeze();
                    } else setDeleteModal(true);
                  }}
                  aria-label="delete"
                  sx={{
                    margin: '0px 2px',
                    padding: '5px',
                    backgroundColor: '#fbc7c7',
                  }}
                >
                  <Delete sx={{ fontSize: '15px', color: '#eb6a6a' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={'Edit'} placement="right" disableInteractive arrow>
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    if (item.serialisactive == 0) {
                      showWarningSnackbar("You can't modify the inactive setting ");
                    } else if (Freeze === 1) {
                      return handleFreeze();
                    } else {
                      setEditID(item);
                    }
                  }}
                  aria-label="delete"
                  sx={{
                    margin: '0px 2px',
                    padding: '5px',
                    backgroundColor: '#D0EFFF',
                  }}
                >
                  <Edit sx={{ fontSize: '15px', color: '#6096d9' }} />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </TableCell>
      </TableRow>
      {backdropOpen && (
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      {activeValueModal && (
        <ListingActive
          text={'settings'} //need to give text that need to show in the modal
          open={activeValueModal}
          editData={item}
          setOpen={setActiveValueModal}
          action={handleStatus}
        />
      )}
      {deleteModal && <DeleteModal open={deleteModal} setOpen={setDeleteModal} func={() => handleDelete(item.id)} text="setting" />}
      {modeModal && (
        <DeleteModal
          open={modeModal.type}
          text2="change"
          setFn={() => setModeModal({ type: false, val: '' })}
          func={() => modeChange(modeModal.val)}
          text="mode"
        />
      )}
    </>
  );
};
export default Setting;
